export const SET_ORDER_STATUS = "shop/SET_ORDER_STATUS";
export const SET_PRODUCTS = "shop/SET_PRODUCTS";
export const SET_DELIVERY = "shop/SET_DELIVERY";
